<template>
    <div>
        <info-modal
            ref="infoModal"
            @ok-submit="closeWindow"
            :msg="infoMsg"
        />

        <info-modal-check-in-detail
            ref="infoModal"
            @ok-submit="closeWindow"
            :msg="infoMsg"
        />

        <liff-error-modal
            ref="errorModal"
            @ok-submit="closeWindow"
            :msg="errorMsg"
        />

        <liff-submit-error-modal
            ref="submitErrorModal"
            @ok-submit="closeWindow"
            :msg="errorMsg"
        />

        <div v-if="isLoading" class="background-loading">
        </div>
        <div class="bg-liff">
            <div class="header-text">
                <div>
                    {{ hearder }}
                </div>
                <span class="lang mr-3">
                    <change-lang />
                </span>
            </div>
            <v-form
                ref="form"
                v-model="valid"
                lazy-validation
                class="form-container"
            >
                <div class="long-do-map" ref="longdoMapValue">
                    <img v-if="isLoadMap" class="pin" src="img/icons/pin.png"/>
                    <longdo-map
                        v-if="isLoadMap"
                        @load="loadMap"
                        :zoom="15"
                        language="en"
                        style="width:100%; height: 300px; pointer-events: none;"
                    />
                </div>
                <div class="content-container">
                    <div>
                        <div class="d-flex-between">
                            <div>
                                {{ $vuetify.lang.t('$vuetify.checkInSale.yourLocation') }}
                            </div>
                            <!-- <div class="text-action">
                                <span
                                    v-if="isLoadMap"
                                    @click="editAddress"
                                >
                                    {{ textAction }}
                                </span>
                            </div> -->
                        </div>
                        <div style="padding-top: 0.5rem;">
                            <span class="name-location" v-if="mode === 'view'">
                                {{ form.address }}
                            </span>
                            <v-textarea
                                v-if="mode === 'edit'"
                                ref="contentTextArea"
                                v-model="form.address"
                                autocomplete="off"
                                outlined
                                :rules="textareaRule"
                                no-resize
                            />
                        </div>
                    </div>
                    <div>
                        <v-text-field
                            v-model="form.jobNo"
                            :label="$vuetify.lang.t('$vuetify.checkInSale.jobId')"
                            autocomplete="off"
                            height="16px"
                            placeholder=""
                            :rules="inputRules"
                        ></v-text-field>
                    </div>
                    <div>
                        <v-text-field
                            v-model="form.customerName"
                            :label="$vuetify.lang.t('$vuetify.checkInSale.customerName')"
                            autocomplete="off"
                            height="16px"
                            placeholder=""
                            :rules="inputRules"
                        ></v-text-field>
                    </div>
                    <div v-if="isUploadFile && mode === 'view'">
                        <div v-if="clientOs === 'ios'">
                            <span>
                                {{ $vuetify.lang.t('$vuetify.liff.attachFile') }}
                            </span>
                            <v-text-field
                                v-model="fileName"
                                :placeholder="$vuetify.lang.t('$vuetify.liff.fileImage')"
                                prepend-inner-icon="mdi-folder-upload"
                                :rules="inputRules"
                                @click="changeFile()"
                                @click:prepend-inner="changeFile()"
                                clearable
                                @click:clear="onClearClicked()"
                                solo
                                height="40px"
                                readonly>
                            </v-text-field>
                            <input
                                ref="file"
                                type="file"
                                class="file-lao"
                                accept="image/*"
                                capture="camera"
                                @change="onSelectFile">
                        </div>
                        <div v-else class="camera-container">
                            <v-icon
                                v-if="isShowIcon"
                                size="36"
                                :class="iconCamera"
                                @click="openCamera" >
                                mdi-camera
                            </v-icon>
                            <video
                                v-show="isShowVideo"
                                ref="cameraView"
                                autoplay >
                            </video>
                            <v-icon
                                v-show="isShowCapture"
                                size="54"
                                class="capture-icon"
                                @click="captureImage" >
                                mdi-circle
                            </v-icon>
                            <v-icon
                                v-show="isShowCapture"
                                size="40"
                                class="swap-camera-icon"
                                @click="swapCamera" >
                                mdi-camera-switch
                            </v-icon>
                            <v-img
                                v-if="capturedImage"
                                :src="capturedImage"
                                alt="Captured"
                                contain
                                height="200" />
                        </div>
                        <span :class="textInformation">* Upload your photo that clearly show your face</span>
                    </div>
                    <div v-if="mode === 'view'">
                        <div class="flex-center">
                            <v-btn
                                cols="6"
                                class="margin-right"
                                color="primary"
                                outlined
                                width="140"
                                @click="closeWindow">
                                {{ $vuetify.lang.t('$vuetify.checkInSale.cancel') }}
                            </v-btn>
                            <v-btn
                                cols="6"
                                width="140"
                                color="primary"
                                :disabled="!isLoadMap"
                                @click="submit">
                                {{ $vuetify.lang.t('$vuetify.checkInSale.submit') }}
                            </v-btn>
                        </div>
                    </div>
                </div>
            </v-form>
        </div>
    </div>
</template>

<script>
import LiffErrorModal from '@/components/modal/LiffErrorModal'
import LiffSubmitErrorModal from '@/components/modal/LiffSubmitErrorModal'
import InfoModal from '@/components/modal/InfoModal'
import InfoModalCheckInDetail from '@/components/modal/InfoModalCheckInDetail'
import ChangeLang from '@/components/liff/ChangeLang'
import { LongdoMap } from 'longdo-map-vue'
import axios from 'axios'
import html2canvas from 'html2canvas'
LongdoMap.init({ apiKey: process.env.VUE_APP_LONGDO_MAP })

export default {
    name: 'CheckInSale',

    components: {
        InfoModalCheckInDetail,
        LiffErrorModal,
        LiffSubmitErrorModal,
        InfoModal,
        ChangeLang,
        LongdoMap
    },

    data () {
        return {
            lineIdToken: null,
            errorMsg: '',
            hasPermission: true,
            isLoading: true,
            mode: 'view',
            infoMsg: null,
            clientOs: null,
            isLoadMap: false,
            form: {
                lineId: '',
                address: this.$vuetify.lang.t('$vuetify.checkInSale.searching'),
                lat: 0,
                lon: 0,
                img: '',
                customerName: '',
                jobNo: ''
            },
            valid: true,
            textareaRule: [
                v => !!v || this.$vuetify.lang.t('$vuetify.checkInSale.fieldRequired')
            ],
            inputRules: [
                v => !!v || this.$vuetify.lang.t('$vuetify.liff.fieldRequired')
            ],
            fileName: '',
            uploadImage: '',
            stream: null,
            capturedImage: null,
            isShowVideo: false,
            isShowIcon: true,
            isShowCapture: false,
            haveImage: true,
            isUploadFile: true,
            currentFacingMode: 'user'
        }
    },

    computed: {
        hearder () {
            return this.$vuetify.lang.t('$vuetify.checkInSale.checkinSale')
        },
        textAction () {
            if (this.mode === 'view') {
                return this.$vuetify.lang.t('$vuetify.checkInSale.edit')
            } else {
                return this.$vuetify.lang.t('$vuetify.checkInSale.save')
            }
        },
        iconCamera () {
            return {
                'default-icon': this.haveImage,
                'red-icon': !this.haveImage
            }
        },
        textInformation () {
            return {
                'font-information': this.haveImage,
                'invalid-font-information': !this.haveImage
            }
        }
    },

    methods: {
        async getCheckInByLinePermission () {
            const body = {
                lineIdToken: this.lineIdToken
            }

            const res = await axios.post(`${process.env.VUE_APP_BACKEND}/check-in-by-line/permission`, body)
            if (res && res.data && res.data.status === 'ok') {
                this.hasPermission = res.data.data
                this.isLoading = false
                if (this.hasPermission) {
                    try {
                        this.getLocation()
                    } catch (e) {
                        this.errorModal(this.$vuetify.lang.t('$vuetify.checkInSale.getLocationError'))
                    }
                } else {
                    this.errorModal(this.$vuetify.lang.t('$vuetify.checkInLocation.hasNoPermission'))
                }
            } else if (res && res.data && res.data.status === 'error') {
                this.errorModal(res.data.msg)
            } else {
                this.errorModal(this.$vuetify.lang.t('$vuetify.checkInSale.networkError'))
            }
        },

        editAddress () {
            if (this.mode === 'view') {
                this.mode = 'edit'
            } else {
                if (this.form.address) {
                    this.mode = 'view'
                } else {
                    this.$refs.contentTextArea.focus()
                }
            }
        },

        async loadMap (map) {
            try {
                // settings UI of longdo maps
                map.Ui.Crosshair.visible(false)
                map.Ui.DPad.visible(false)
                map.Ui.Zoombar.visible(false)
                map.Ui.Geolocation.visible(false)
                map.Ui.LayerSelector.visible(false)
                map.Ui.Toolbar.visible(false)
                map.Ui.Fullscreen.visible(false)
                map.location({ lon: this.form.lon, lat: this.form.lat })

                this.form.address = await this.getAddress(this.form.lon, this.form.lat)
                this.$store.dispatch('setLoading', false)
            } catch (err) {
                this.errorModal(this.$vuetify.lang.t('$vuetify.checkInSale.networkError'))
            }
        },

        async getAddress (lon, lat) {
            try {
                let name = ''
                const res = await axios.get(`https://api.longdo.com/map/services/address?lon=${lon}&lat=${lat}&key=${process.env.VUE_APP_LONGDO_MAP}`, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })

                if (res && (typeof res.data === 'object')) {
                    const data = res.data
                    if (data.aoi) {
                        // get name place
                        name = data.aoi
                    } else if (data.province) {
                        name = ''
                        if (data.house_num) {
                            name += `${data.house_num} `
                        }
                        if (data.road) {
                            name += `${data.road} `
                        }
                        if (data.subdistrict) {
                            name += `${data.subdistrict} `
                        }
                        if (data.district) {
                            name += `${data.district} `
                        }
                        if (data.province) {
                            name += `${data.province} `
                        }
                        if (data.postcode) {
                            name += `${data.postcode}`
                        }
                    }
                }

                return name
            } catch (err) {
                this.errorModal(err)
            }
        },

        successGetPosition (pos) {
            const crd = pos.coords
            if (crd.latitude && crd.longitude) {
                this.form.lat = crd.latitude
                this.form.lon = crd.longitude
                this.isLoadMap = true
            }
        },

        // Get location {lat = latitude, lot = longitude}
        getLocation () {
            try {
                const geo = navigator.geolocation
                const options = {
                    timeout: 5000,
                    maximumAge: 0 // age of location
                }

                geo.getCurrentPosition(this.successGetPosition, this.errorAlert, options)
            } catch (e) {
                this.errorModal(this.$vuetify.lang.t('$vuetify.checkInSale.getLocationError'))
            }
        },

        changeFile () {
            this.$refs.file.click()
        },

        async openCamera () {
            try {
                this.stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user' } })
                this.$refs.cameraView.srcObject = this.stream
                this.haveImage = false
                this.isShowVideo = true
                this.isShowIcon = false
                this.isShowCapture = true
                this.haveImage = true
                this.capturedImage = null
            } catch (error) {
                this.errorModal(error)
            }
        },

        captureImage () {
            try {
                const video = this.$refs.cameraView
                const canvas = document.createElement('canvas')
                canvas.width = video.videoWidth
                canvas.height = video.videoHeight
                const ctx = canvas.getContext('2d')

                ctx.drawImage(video, 0, 0, canvas.width, canvas.height)

                const dataURI = canvas.toDataURL('image/jpeg')

                this.uploadImage = dataURI
                this.capturedImage = dataURI

                this.isShowIcon = true
                this.isShowCapture = false
                this.isShowVideo = false
                this.haveImage = true
                this.stream.getTracks().forEach((track) => { track.stop() })
            } catch (error) {
                this.errorModal(error)
            }
        },

        async swapCamera () {
            try {
                const newFacingMode = this.currentFacingMode === 'user' ? 'environment' : 'user'

                if (this.stream) {
                    this.stream.getTracks().forEach((track) => track.stop())
                }

                this.stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: newFacingMode } })
                // navigator.permissions.revoke(this.stream)
                this.$refs.cameraView.srcObject = this.stream
                this.currentFacingMode = newFacingMode
            } catch (error) {
                this.errorModal(error)
            }
        },

        onSelectFile (files) {
            const fileList = event.target.files

            const reader = new FileReader()
            if (fileList[0]) {
                reader.onload = () => {
                    //  reader.result is base64
                    this.uploadImage = reader.result
                }

                reader.readAsDataURL(fileList[0])
                this.fileName = fileList[0].name
            }
        },

        onClearClicked () {
            this.fileName = ''
            this.uploadImage = ''
        },

        async submit () {
            if (!this.$refs.form.validate()) {
                return
            }

            if (!this.capturedImage && this.clientOs !== 'ios') {
                this.haveImage = false
                return
            }

            this.$store.dispatch('setLoading', true)
            try {
                const canvas = await html2canvas(this.$refs.longdoMapValue, {
                    // Whether to attempt to load images from a server using CORS
                    useCORS: true
                })

                this.form.img = canvas.toDataURL('image/png')
            } catch (error) {
                this.errorModal(error)
            }

            if (this.form.img) {
                const { address, lat, lon, img, customerName, jobNo } = this.form
                this.form = {
                    lineIdToken: this.lineIdToken,
                    address: address,
                    lat: lat,
                    lon: lon,
                    customer_name: customerName,
                    job_no: jobNo
                }

                if (this.isUploadFile) {
                    this.form = {
                        ...this.form,
                        attachmentFile: this.uploadImage,
                        mapFile: img,
                        lineIdToken: this.lineIdToken
                    }
                } else {
                    this.form = {
                        ...this.form,
                        img: img,
                        user_id: this.lineId
                    }
                }
            }

            const res = await axios.post(`${process.env.VUE_APP_BACKEND}/receive-alarm/line-for-sale`, this.form, {
                headers: { 'Accept-Language': this.$vuetify.lang.current }
            })
            if (res && res.data && res.data.status === 'ok') {
                this.$store.dispatch('setLoading', false)
                const data = res.data.data
                this.infoMsg = `<span class="info-content">${data.date}<br>คุณได้ลงเวลาสำเร็จ ณ ${data.time} น.</span>`
                this.$refs.infoModal.dialog = true
            } else {
                this.submitErrorModal(res.data.msg)
            }
        },

        setInitEnv () {
            return process.env.VUE_APP_LINE_CHECK_IN_SALE_URL
        },

        closeWindow () {
            this.$liff.closeWindow()
        },

        errorModal (message) {
            this.$store.dispatch('setLoading', false)
            this.$refs.errorModal.dialog = true
            this.errorMsg = message
        },

        submitErrorModal (message) {
            this.$store.dispatch('setLoading', false)
            this.$refs.submitErrorModal.dialog = true
            this.errorMsg = message
        },

        errorAlert () {
            this.errorModal(this.$vuetify.lang.t('$vuetify.checkInSale.msgGPSError'))
        }
    },

    async mounted () {
        this.$store.dispatch('setLoading', true)
        try {
            this.clientOs = this.$util.getLineOs()
            this.lineIdToken = await this.$util.getLineIdToken(this.setInitEnv())
            await this.getCheckInByLinePermission()
        } catch (error) {
            this.errorModal(this.$vuetify.lang.t('$vuetify.checkInSale.cannotGetLineId'))
        }
        this.$store.dispatch('setLoading', false)
    }
}
</script>

<style lang="scss" scoped>
::v-deep .ldmap_placeholder {
    margin: 0px !important;
    border-top-left-radius: 30px !important;
    border-top-right-radius: 30px !important;
}

::v-deep .v-text-field .v-input__control > .v-input__slot{
    height: 10px;
}

video {
  height: 70%;
  width: 100%;
}

.camera-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.capture-icon {
  color: white;
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
}

.swap-camera-icon {
  color: white;
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
}

.red-icon {
  color: #FF5252;
}

.default-icon {
  color: #9E9E9E;
}

.flex-center {
    bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: flex-end;
}

.margin-right {
    margin-right: 16px;
}

.bg-liff {
    height: 100vh;
    background-color: #2E2929;
    color: #ffffff;

    .header-text {
        font-family: LexendDeca;
        font-size: 20px;
        padding: 1rem;
        height: 10%;
        min-height: 45px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .form-container {
        background: #ffffff;
        border-top-right-radius: 30px;
        border-top-left-radius: 30px;
        color: #6c6c6c;
        font-size: 14px;
        font-weight: normal;
        overflow: scroll;
        height: 90%;
    }

    .content-container {
        padding: 1.5rem;
        background: #ffffff;
        color: #6c6c6c;
        font-size: 14px;
        font-weight: normal;
        min-height: calc(100% - 300px);
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .text-action {
            color: #d76436;
        }
    }

    .long-do-map {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #95a5a6;
        height: 300px;
        border-top-left-radius: 30px !important;
        border-top-right-radius: 30px !important;
    }

    .pin {
        position: absolute;
        z-index: 2;
        margin-top: -32px;
    }

    .font-information {
        font-size: 14px;
        color: #a8a8a8;
        text-align: center;
    }

    .invalid-font-information {
        font-size: 14px;
        color: #FF5252;
        text-align: center;
    }
}

@media screen and (orientation: landscape) {
    .bg-liff {
        display: flex;
        flex-direction: column;
        align-items: center;

        .form-container {
            min-width: 350px;
        }
    }
}

.name-location {
    overflow-wrap: break-word;
    word-break: break-all;
    display: block;
    font-weight: bold;
}

.lang {
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 18px;
    &-th{
        font-family: Prompt;
    }
    &-en{
        font-family: LexendDeca;
    }
}

.text-underline {
    text-decoration: underline;
    color: #d76436;
}

.file-lao {
    display: none;
}
.no-permission {
    height: 100vh;
    background-color: #f7f7f7;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 3rem;
}

.no-permission-text {
    margin-top: 2rem;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.56;
    letter-spacing: normal;
    text-align: center;
    color: #131410;
    font-family: LexendDeca;
}

.background-loading {
    height: 100vh;
    background-color: #f7f7f7;
    position: fixed;
    z-index: 100;
    width: 100vw;
}

.info-content {
    line-height: 8rem;
    text-align: center;
}
</style>
